export const myCustomLightTheme = {
    dark: false,
    colors: {
      'background': 'rgb(255, 255, 255)',
      'surface': 'rgb(255, 255, 255)',
      'surface-bright': 'rgb(255, 255, 255)',
      'surface-light': 'rgb(238, 238, 238)',
      'surface-variant': 'rgb(66, 66, 66)',
      'on-surface-variant': 'rgb(238, 238, 238)',
      'primary': 'rgb(66, 108, 249)',
      'primary-darken-1': 'rgb(31, 85, 146)',
      'secondary': 'rgb(72, 169, 166)',
      'secondary-darken-1': 'rgb(1, 135, 134)',
      'error': 'rgb(255, 39, 39)',
      'info': 'rgb(9, 0, 49)',
      'success': 'rgb(54, 192, 112)',
      'warning': 'rgb(251, 140, 0)',
    },
    variables: {
      'border-color': 'rgb(0, 0, 0)',
      'border-opacity': 0.12,
      'high-emphasis-opacity': 0.87,
      'medium-emphasis-opacity': 0.60,
      'disabled-opacity': 0.38,
      'idle-opacity': 0.04,
      'hover-opacity': 0.04,
      'focus-opacity': 0.12,
      'selected-opacity': 0.08,
      'activated-opacity': 0.12,
      'pressed-opacity': 0.12,
      'dragged-opacity': 0.08,
      'theme-kbd': 'rgb(33, 37, 41)',
      'theme-on-kbd': 'rgb(255, 255, 255)',
      'theme-code': 'rgb(245, 245, 245)',
      'theme-on-code': 'rgb(0, 0, 0)',
      'yhl': 'rgba(47, 0, 255, 0.6)'
    }
  }
  